import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GraphService } from '../api/graph.service';
import { AppSync } from './appSync.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private notificationsSubject = new BehaviorSubject<any[]>([]);
  allNotifications = this.notificationsSubject.asObservable();

  constructor(private querySync: AppSync, private queryGQL: GraphService) {}

  setNotifications(notifications: any[]) {
    this.notificationsSubject.next(notifications);
  }

  getNotifications() {
    return this.allNotifications;
  }

  addNotification(notification: any) {
    const currentNotifications = this.notificationsSubject.value;
    const index = currentNotifications.findIndex(
      (notif: any) => notif.id === notification.id
    );
    if (index > -1) {
      currentNotifications[index] = notification;
    } else {
      currentNotifications.push(notification);
    }

    this.notificationsSubject.next([...currentNotifications]);
  }
  OnUpdateExploNotificationsDev() {
    // Iniciando subscription a notificaciones DEV con userPool auth
    return this.querySync.subscribeGraphQLAppSyncWithAuth<any>({
      query: `
          subscription onUpdateExploNotificationsDev {
            onUpdateExploNotificationsDev {
                 id    	
                  changedData{
                    fieldName
                    newValue
                    oldValue
                  }
                  changeType
                  createdAt
                  fieldNamePrincipal
                  idValue

                  isLM
                  
                  tableName
                  updatedAt

                  readSales
                  readOp
                  
                  nombreItinerario
                  fileNumber
                  details
                  usuario
                  by
            }
          }
        `,
      authMode: 'userPool',
    });
  }

  OnUpdateExploNotificationsPrd() {
    // Iniciando subscription a notificaciones PRD con userPool auth
    return this.querySync.subscribeGraphQLAppSyncWithAuth<any>({
      query: `
          subscription onUpdateExploNotificationsPrd {
            onUpdateExploNotificationsPrd {
                 id    	
                  changedData{
                    fieldName
                    newValue
                    oldValue
                  }
                  changeType
                  createdAt
                  fieldNamePrincipal
                  idValue
                  
                  isLM

                  tableName
                  updatedAt

                  readSales
                  readOp
                  
                  nombreItinerario
                  fileNumber
                  details
                  usuario
                  by
            }
          }
        `,
      authMode: 'userPool',
    });
  }

  GetAllNotifications() {
    return this.queryGQL.queryGraphQLSales<Notification[]>({
      query: `query{
          getAllNotifications{
            id    	
            changedData{
              fieldName
              newValue
              oldValue
            }
            changeType
            createdAt
            fieldNamePrincipal
            idValue

            isLM
            
            tableName
            updatedAt

            readSales
            readOp
            

            fileNumber
            nombreItinerario
            details
            usuario
            by
          }
        }`,
      variables: {},
    });
  }

  readNotificationById(id: String, user: String, area: String) {
    return this.queryGQL.queryGraphQLSales<Notification[]>({
      query: `
        mutation readNotificationById($id: String!, $user: String!,  $area: String!) {
            readNotificationById(id: $id, user: $user, area: $area)
          }
        `,
      variables: { id, user, area },
    });
  }

  listExploNotificationsDevs() {
    return this.querySync.queryGraphQLAppSync<any>({
      query: `
      query listExploNotificationsDevs{
        listExploNotificationsDevs {
          items{
              id
              updatedAt
          }
        }
      }
    `,
      variables: {},
    });
  }
}
